import Vue from "vue"
import Vapi from "vuex-rest-api"

const bookings = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    booking: null,
    bookings: [],
    allBookings: [],
  },
})

  // bookings
  .get({
    action: "listBookings",
    property: "bookings",
    path: ({ showId }) => `/bookings/?show=${showId}`,
  })
  .get({
    action: "listAllBookings",
    property: "allBookings",
    path: ({ showId }) => `/bookings/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createBooking",
    path: "/bookings/",
  })
  .patch({
    action: "updateBooking",
    path: ({ id }) => `/bookings/${id}/`,
  })
  .delete({
    action: "destroyBooking",
    path: ({ id }) => `/bookings/${id}/`,
  })

  // finalize
  .getStore()

export default bookings
